var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8 9C14.8 12.2033 12.2033 14.8 9 14.8C5.79675 14.8 3.2 12.2033 3.2 9C3.2 5.79675 5.79675 3.2 9 3.2C12.2033 3.2 14.8 5.79675 14.8 9ZM14.3555 13.5078C15.3817 12.2899 16 10.7172 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C10.7172 16 12.2899 15.3817 13.5078 14.3555C13.5136 14.3619 13.5196 14.3681 13.5257 14.3743L16.8257 17.6743C17.0601 17.9086 17.4399 17.9086 17.6743 17.6743C17.9086 17.4399 17.9086 17.0601 17.6743 16.8257L14.3743 13.5257C14.3681 13.5196 14.3619 13.5136 14.3555 13.5078Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.51217ed7f546d3e2fc7f3ffd4881bad7.svg";
export { ForwardRef as ReactComponent };